import { render, staticRenderFns } from "./Consentement.vue?vue&type=template&id=ed209886"
import script from "./Consentement.vue?vue&type=script&lang=js"
export * from "./Consentement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports